<template>
  <div id="app">
    <div class="content">
<!--      <keep-alive>-->
<!--        <router-view ></router-view>-->
<!--      </keep-alive>-->

      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
<!--    <keep-alive>-->
    <Footer class="footer"/>
<!--    </keep-alive>-->
  </div>
</template>

<script>
import NavTop from './components/comcomponents/NavTop'
import Footer from './components/comcomponents/Footer'

export default {
  name: 'App',
  components: {
    NavTop, Footer
  }
}
</script>
<style>
</style>




// WEBPACK FOOTER //
// src/App.vue